import * as state from '@/state';
import { useAtomValue } from 'jotai';

export const usePointSize = () => {
  const pointSize = useAtomValue(state.pointSize);
  const dynamicPointSize = useAtomValue(state.dynamicPointSize);
  const enableDynamicPointSize = useAtomValue(state.enableDynamicPointSize);

  return {
    enableSizeAttenuation: enableDynamicPointSize,
    pointSize: enableDynamicPointSize ? dynamicPointSize : pointSize,
  };
};
